module.exports = __webpack_public_path__ + "img/test-incomplete.e8065ff0.svg";